var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-288 -447) translate(48 279) translate(0 168) translate(240)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#586179",
    d: "M11.3 18.708l-8.01-8.067c-.387-.389-.387-1.02 0-1.408l.934-.941c.386-.389 1.01-.39 1.397-.002L12 14.683l6.379-6.393c.386-.387 1.011-.387 1.397.002l.934.94c.387.39.387 1.02 0 1.41l-8.01 8.066c-.387.39-1.013.39-1.4 0z",
    transform: "translate(-288 -447) translate(48 279) translate(0 168) translate(240)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon-chevron-down.c8792428.svg";
export { ForwardRef as ReactComponent };